module.exports = __webpack_public_path__ + "img/air_red.309d80d2.svg";